import Post from "../components/post";
import { useEffect, useState, useContext } from "react";
// import { UserContext } from "../UserContext"; // old
import { UserContext } from "../context/UserContext"; // new import
import { useNavigate } from "react-router-dom"; // Importar useNavigate
import "../styles/Pages/ArticlesPage.css";
import Pagination from "../components/Pagination";

export default function IndexPage() {
  const [posts, setPosts] = useState([]); // Todos los posts desde el servidor
  const [loading, setLoading] = useState(true); // Estado de carga
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(6);
  const { userInfo } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://api-portfolio-arturo.vercel.app/post")
      .then((response) => response.json())
      .then((posts) => {
        setPosts(
          posts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setLoading(false); // Finaliza la carga
      });
  }, []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const username = userInfo?.username; // Verificar si hay usuario logueado

  const handleCreateArticle = () => {
    navigate("/create");
  };

  return (
    <div className='containerPostPage'>
      <div className='ContainerPost'>
        <h2 className='TituloArticulos'>Artículos</h2>
        <div className='BtnContainerArticulo'>
          {/* Renderizar el botón solo si el usuario está logueado */}
          {username && (
            <button className='btnCrearArticulo' onClick={handleCreateArticle}>
              <ion-icon name='add-outline'></ion-icon>
              Crear articulo
            </button>
          )}
        </div>
        <div className='PostIndexPage'>
          {loading ? (
            <div className='loader-container'>
              <div className='loader'></div>
            </div>
          ) : posts.length === 0 ? (
            <p>No hay artículos disponibles.</p> // Mensaje de no hay artículos
          ) : (
            currentPosts.map((post) => <Post key={post._id} {...post} />)
          )}
        </div>
        {/* Paginación */}
        {!loading && posts.length > 0 && (
          <Pagination
            postsPerPage={postsPerPage}
            totalPosts={posts.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
  );
}
